<template>
    <div>
        <a-modal v-model="isVisible" :closable="false" title="Adjust pickup time" on-ok="handleOk">
            <template slot="footer">
                <a-button type="primary" @click="handleBtnUpdate">
                    Update
                </a-button>

                <a-button key="back" @click="handleBtnCancel">
                    Close
                </a-button>
            </template>
            <a-row>
                <a-form-model ref="pickupTimeEditForm"
                            :model="pickupTimeEditModel"
                >
                    <a-row :gutter="[24]">
                        <a-col :span="12">
                            <a-form-model-item label="ASAP" prop="asap">
                                <a-checkbox v-model="pickupTimeEditModel.asap">
                                    ASAP
                                </a-checkbox>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="12">
                            <a-form-model-item label="Priority" prop="priority">
                                <a-checkbox v-model="pickupTimeEditModel.priority">
                                    Priority
                                </a-checkbox>
                            </a-form-model-item>
                        </a-col>
                    </a-row> 
                </a-form-model>
            </a-row>
        </a-modal>
       
    </div>
</template>

<script>
export default {

    data () {
        
        return {
            orderId : null,
            pickupTimeEditModel : {
                asap : null,
                priority : null
            },
            isVisible : false,
        }
    },
    
    methods : {

        show(record) {
            //console.log(order)
            this.isVisible = true;
            this.orderId = record.orderId;
            
            this.pickupTimeEditModel.asap = record.asap;
            this.pickupTimeEditModel.priority = record.priority;
        },

        handleOk ()  {
            this.isVisible = false;
            this.reset();
        },
        handleBtnCancel () {
            this.isVisible = false;
            this.reset();
        },

        async handleBtnUpdate() {

            this.$message.loading('Updating data...', 5);
            let record = {
                orderId : this.orderId,
                asap: this.pickupTimeEditModel.asap,
                priority : this.pickupTimeEditModel.priority
            };

            let isSuccess = await this.$store.dispatch('orderManager/updateOrderPriorityOrAsapAction', record);
            if(isSuccess == null) {
				this.$message.error('Something was wrong, please try again!', 5);
			}
			else {
				this.$message.success('Update successfully!', 3);
			}
            this.isVisible = false;
            this.reset();
			this.$message.destroy();
        },

      
        reset() {
            this.orderId = null;
            this.pickupTimeEditModel.asap = null;
            this.pickupTimeEditModel.priority = null;
        }
    }
}
</script>

<style>

</style>